export default "__VITE_ASSET__5PskZREW__"